import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { IRouteIFrameRequest } from "types";

type InitialState = {
  data: IRouteIFrameRequest;
};

const initialState: InitialState = {
  data: {
    prioritizedTags: [],
    avoid: ["MOTORWAY"],
    tags: {
      nature: [],
      history: [],
      urban: [],
      amusements: [],
    },
    roadType: undefined,
    startAsFinish: false,
    buildVariant: "linear",
    duration: undefined,
  },
};

const slice = createSlice({
  name: "routeRequest",
  initialState: initialState,
  reducers: {
    setRouteRequest: (
      state,
      action: PayloadAction<Partial<IRouteIFrameRequest>>
    ) => {
      state.data = { ...state.data, ...action.payload };
    },
    resetRouteRequest: (state) => {
      state.data = initialState.data;
    },
  },
});

export const {
  reducer,
  actions: { setRouteRequest, resetRouteRequest },
} = slice;
